import { PropsWithChildren } from 'react';
import { useRedirectHandler } from '@antimatterhq/ui/hooks/auth/useRedirectHandler';
import { RedirectErrorMessage } from '@antimatterhq/ui/components/redirectError';
import { useStandaloneAuthentication } from '@/hooks/authentication/useStandaloneAuthentication';

export default function RedirectHandler({ children }: PropsWithChildren) {
  const { refreshAuthentication } = useStandaloneAuthentication();
  const { isCheckingRedirect, redirectError } = useRedirectHandler({
    prefix: 'standalone',
  });

  if (redirectError) {
    return (
      <RedirectErrorMessage
        error={redirectError}
        initiateAuthentication={refreshAuthentication}
        prefix="standalone"
      />
    );
  }

  return (
    <>
      {isCheckingRedirect === undefined || isCheckingRedirect === true
        ? null
        : children}
    </>
  );
}
